<template>
  <v-form ref="form" style="width: 100%; padding-top: 0px;" v-model="formIsValid">
    <v-card-text>
      <v-text-field :rules="[rules.required]" required v-model="formObject.synonymName" label="Alias name" />
      <template v-if="isDepthHeightDatum">
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-autocomplete :items="datumList" :rules="[rules.required]" required item-text="DatumName" v-model="synonymData.targetDatum" label="Select Datum" return-object />
          </v-flex>
          <v-flex xs12 offset-md1 md3>
            <v-text-field v-if="synonymData.targetDatum && synonymData.targetDatum.DatumType" disabled v-model="synonymData.targetDatum.DatumType.Name" label="Datum Type" />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm6 md5>
            <v-text-field label="Enter start value in m" type="number" v-model.number="synonymData.depthHeightStartValue" :rules="[rules.depthHeightRules, rules.requiredNumber]" />
          </v-flex>
          <v-spacer />
          <v-flex xs12 sm6 md5>
            <v-text-field label="Enter end value in m" type="number" v-model.number="synonymData.depthHeightEndValue" :rules="[rules.depthHeightRules, rules.requiredNumber]" />
          </v-flex>
        </v-layout>
      </template>
      <template v-if="isSystemAdmin">
        <v-subheader class="pl-0">System Administrator Settings</v-subheader>
        <v-checkbox color="info" class="mt-0" v-model="formObject.isPrimary" label="Make primary alias" persistent-hint hint="The primary alias is the name used in reports" />
      </template>
    </v-card-text>

    <v-alert key="alert" outline class="my-0" type="warning" :value="formObject.isPrimary">
      <div class="primary--text">
        The primary alias name shows up in reports, which may cause confusion if the primary alias does not match the
        location name.
      </div>
    </v-alert>
  </v-form>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const datums = createNamespacedHelpers('datum')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')
  const app = createNamespacedHelpers('app')
  const stationManagement = createNamespacedHelpers('stationmanagement')
  const synonyms = createNamespacedHelpers('synonyms')
  const authenticate = createNamespacedHelpers('authenticate')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    props: {
      isQaQc: {
        type: Boolean,
        default: false,
      },
      isDepthHeightDatum: {
        type: Boolean,
        default: false,
      },
      givenStation: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        formObject: {
          synonymName: null,
          isPrimary: false,
        },
        synonymData: {
          targetDatum: null,
          depthHeightStartValue: null,
          depthHeightEndValue: null,
        },
        initialSynonymData: {
          targetDatum: null,
          depthHeightStartValue: null,
          depthHeightEndValue: null,
        },
        rules: {
          depthHeightRules: value => {
            if (value < 0) return 'Value can not be negative'
            if (isNaN(value)) return 'Value must be a number/decimal'
            if (this.formObject.depthHeightStartValue &&
              this.formObject.depthHeightEndValue &&
              this.formObject.depthHeightStartValue > this.formObject.depthHeightEndValue) {
              return 'Start value must be less than end value'
            }

            return true
          },
          required: value => !!value || 'Required', // 0 fails this rule
          requiredNumber: value => (!!value || value === 0) || 'Required',
        },
        formIsValid: true,
      }
    },
    computed: {
      ...datums.mapGetters(['datumList']),
      ...monitoringFeatures.mapGetters([]),
      ...dataSources.mapGetters(['dataSources']),
      ...authenticate.mapGetters(['isSystemAdmin']),
    },
    watch: {
      isDepthHeightDatum() {
        this.synonymData = JSON.parse(JSON.stringify(this.initialSynonymData))
      },
      formIsValid(value) {
        this.$emit('update:valid', value)
      },
    },
    methods: {
      ...stationManagement.mapActions(['editStationName']),
      ...dataSources.mapActions(['fetchDataSources']),
      ...app.mapActions(['setSnackbar']),
      ...synonyms.mapActions(['addSynonym']),
      close() {
        this.$emit('close')
      },
      async submit() {
        if (!this.$refs.form.validate()) return

        try {
          await this.addSynonym({
            synonymName: this.formObject.synonymName,
            isPrimary: this.formObject.isPrimary,
            sourceType: SOURCE_TYPES.discreteEnvirodata,
            sourceId: this.givenStation.Id,
            synonymData: {
              isQaQc: this.isQaQc,
              isDepthHeightDatum: this.isDepthHeightDatum,
              depthHeightDatumId: this.synonymData.targetDatum && this.synonymData.targetDatum.Id,
              depthHeightStartValue: this.synonymData.depthHeightStartValue,
              depthHeightEndValue: this.synonymData.depthHeightEndValue,
            },
          })

          await this.fetchDataSources({
            sourceTypes: [SOURCE_TYPES.discreteEnvirodata],
          })

          this.setSnackbar({
            text: this.$t('StationEditNameDialog.saveSuccessMsg'),
            color: 'success',
            icon: 'done',
          })

          this.close()
        } catch (error) {
          console.error(error)
          let errorText = error.Message ? error.Message : error
          this.setSnackbar({
            text: errorText,
            color: 'error',
            icon: 'error',
          })
        }
      },
    },
  }
</script>